import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { BottomSheet as AtlasBottomSheet } from '@daedalus/atlas/BottomSheet';
import { Divider } from '@daedalus/atlas/Divider';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { getError } from '../../modules/selector';
import { BookingCreation } from '../BookingCreation';
import { ErrorAlert } from '../ErrorMessage/ErrorAlert';
import { SimplifiedHotelCard } from '../SimplifiedHotelCard';
import { FreezeCTA } from './FreezeCTA';
import { FreezeDetailsHeader } from './FreezeDetailsHeader';
import { OfferCheck } from './OfferCheck';
import { HotelCardSkeleton } from './SkeletonLoading';
const LoaderWrapper = /*#__PURE__*/styled('div')({
  name: "LoaderWrapper",
  class: "l8ssei4",
  propsAsIs: false
});
const MobileCtaWrapper = /*#__PURE__*/styled('div')({
  name: "MobileCtaWrapper",
  class: "m18egkja",
  propsAsIs: false
});
const _exp2 = /*#__PURE__*/() => AtlasBottomSheet;
const FreezeBottomSheet = /*#__PURE__*/styled(_exp2())({
  name: "FreezeBottomSheet",
  class: "fmk3wne",
  propsAsIs: true
});
interface Props {
  offerLink: string | undefined;
  isOpen: boolean;
  isCreateBookingLoading: boolean;
  isPageLoading: boolean;
  hideOverlay: () => void;
  handleCreateFreezeBooking: () => void;
  // Skips bottom sheet animations (sheet instantly snaps to desired location)
  reduceMotion?: boolean;
}
export const FreezeDetailsMobile: React.FC<Props> = ({
  isOpen,
  offerLink,
  isCreateBookingLoading,
  isPageLoading,
  hideOverlay,
  handleCreateFreezeBooking,
  reduceMotion = false
}) => {
  const {
    errored
  } = useSelector(getError);
  const Content = useMemo(() => {
    if (isPageLoading) return <HotelCardSkeleton />;
    if (isCreateBookingLoading) {
      return <LoaderWrapper>
          <BookingCreation />
        </LoaderWrapper>;
    }
    return <Flex.Column gap="s400">
        <ErrorAlert />
        <SimplifiedHotelCard />
      </Flex.Column>;
  }, [isCreateBookingLoading, isPageLoading]);
  return <FreezeBottomSheet isOpen={isOpen} onClose={hideOverlay} titleBarProps={{
    centerContent: '',
    hasDivider: false
  }} headerVariant="default" snapPoints={{
    top: 'nearFull',
    middle: 0.85
  }} prefersReducedMotion={reduceMotion} subHeaderContent={!isCreateBookingLoading && <ContentWrapper paddingTop="s700" paddingX="s500">
            <FreezeDetailsHeader alignment="center" isLoading={isPageLoading} />
          </ContentWrapper>} footerContent={!isCreateBookingLoading && !errored && <MobileCtaWrapper>
            <Divider />
            <ContentWrapper padding="s500" paddingBottom="s700">
              <FreezeCTA isPageLoading={isPageLoading} handleCreateFreezeBooking={handleCreateFreezeBooking} ctaTitleText={<FormattedMessageWrapper id="df.oneTapToFreeze" defaultMessage="One tap to freeze – zero obligation to book." />} />
            </ContentWrapper>
          </MobileCtaWrapper>}>
      {isOpen && <>
          {offerLink && <OfferCheck offerLink={offerLink} />}
          {Content}
        </>}
    </FreezeBottomSheet>;
};

require("./FreezeDetailsMobile.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./FreezeDetailsMobile.tsx");